import { useState, useEffect, useRef } from "react";
import { useParams } from "react-router";
import { TestRunStore } from "stores";
import { TestResult, TestStatus } from "models/test-run";
import Page from "pages/page";
import TestResultDisplay from "components/test-result";

const TestResultPage = () => {
  const { testRunId, testId } = useParams<{ testRunId: string; testId: string }>();
  const testRunTestId = parseInt(testId);
  const testRunIdn = parseInt(testRunId);
  const [testResult, setTestResult] = useState(null as TestResult);
  const doRefreshRef = useRef(false);

  // Load test result when params change
  useEffect(() => {
    // Clear previous result immediately to show loading state
    setTestResult(null);
    doRefreshRef.current = false;

    const load = async () => {
      const result = await TestRunStore.getTestResult(testRunIdn, testRunTestId);
      setTestResult(result);

      // Start polling if test is running or pending
      if (result.status === TestStatus.RUNNING || result.status === TestStatus.PENDING) {
        doRefreshRef.current = true;
        startPolling(testRunIdn, testRunTestId);
      }
    };

    const startPolling = async (runId: number, testId: number) => {
      const pollDelay = 5 * 1000; // 5s

      const poll = async () => {
        if (!doRefreshRef.current) return;

        const result = await TestRunStore.getTestResult(runId, testId);
        setTestResult(result);

        const spinner = document.getElementById("loading-spinner");
        if (spinner) {
          spinner.scrollIntoView();
        }

        // Continue polling if still running or pending
        if (result.status === TestStatus.RUNNING || result.status === TestStatus.PENDING) {
          setTimeout(poll, pollDelay);
        }
      };

      setTimeout(poll, pollDelay);
    };

    load();

    return () => {
      doRefreshRef.current = false;
    };
  }, [testRunIdn, testRunTestId]);

  return (
    <Page name="test-results" title="Test Results" titleSize="none">
      <TestResultDisplay key={`${testRunIdn}-${testRunTestId}`} testResult={testResult} />
    </Page>
  );
};

export default TestResultPage;
